document.addEventListener('DOMContentLoaded', () => {
  const tierCard = document.getElementById('tr-tier-card');
  if (!tierCard) return;

  function getTrumpetQty() {
    // Jouw custom cart item wrapper
    const items = document.querySelectorAll('article.tr-cart-item');
    for (const item of items) {
      const titleLink = item.querySelector('.tr-cart-item__title a');
      const title = (titleLink?.textContent || '').toLowerCase();

      if (title.includes('trumpet')) {
        const input = item.querySelector('input.quantity__input[name="updates[]"]');
        if (!input) return null;

        const v = parseInt(input.value, 10);
        return Number.isFinite(v) ? v : null;
      }
    }

    // fallback: eerste quantity input
    const first = document.querySelector('input.quantity__input[name="updates[]"]');
    if (!first) return null;
    const v = parseInt(first.value, 10);
    return Number.isFinite(v) ? v : null;
  }

  function highlightTier(qty) {
    const rows = tierCard.querySelectorAll('.tr-tier__row');
    rows.forEach(r => r.classList.remove('is-active'));
    if (qty == null) return;

    for (const row of rows) {
      const min = parseInt(row.dataset.min || '0', 10);
      const max = row.dataset.max ? parseInt(row.dataset.max, 10) : null;

      const match = (max === null) ? qty >= min : (qty >= min && qty <= max);
      if (match) {
        row.classList.add('is-active');
        break;
      }
    }
  }

  function refresh() {
    highlightTier(getTrumpetQty());
  }

  // init
  refresh();

  // qty handmatig wijzigen
  document.addEventListener('change', (e) => {
    if (e.target && e.target.matches('input.quantity__input[name="updates[]"]')) {
      refresh();
    }
  });

  // plus/minus knoppen (jouw markup gebruikt .quantity__button)
  document.addEventListener('click', (e) => {
    if (e.target.closest('button.quantity__button')) {
      setTimeout(refresh, 200);
    }
  });

  // als jouw cart via ajax re-rendered: opnieuw proberen
  document.addEventListener('cart:updated', () => setTimeout(refresh, 200));
});
